import fetch,{getBlob} from '../utils/fetch';

export function addActivity(params) {
	return fetch({
		method: 'POST',
		url: '/activityManage/addActivity',
		data: params
	})
}

export function auditActivity(params) {
	return fetch({
		method: 'POST',
		url: '/activityManage/auditActivity',
		data:params
	})
}

export function deleteActivity(params) {
	return fetch({
		method: 'GET',
		url: '/activityManage/deleteActivity',
		params
	})
}

export function findActivityDetail(params) {
	return fetch({
		method: 'GET',
		url: '/activityManage/findActivityDetail',
		params
	})
}

export function findActivityList(params) {
	return fetch({
		method: 'POST',
		url: '/activityManage/findActivityList',
		data: params
	})
}

//activityManage/exportActivityList
export function exportActivityList(params) {
	return getBlob({
		method: 'POST',
		url: '/activityManage/exportActivityList',
		data: params
	})
}